import * as React from 'react';

import axios, { AxiosResponse } from 'axios';
import moment from 'moment';

type ConvoPDFState = {
  report: any;
};

export default class ConvoPDFComponent extends React.Component<
  any,
  ConvoPDFState
> {
  constructor(props: any) {
    super(props);

    this.state = { report: null };
    // Get convos through InstantMessagingController
    axios
      .get('/messaging/v1/convo/0', {
        params: { reportId: props.reportId, isForExport: true },
      })
      .then((result: AxiosResponse<any>) => {
        this.setState({
          report: result.data,
        });
      });
  }
  // TODO: Define interfaces for convos and messages instead of using any

  render() {
    // Show loading animation
    if (!this.state.report) {
      return (
        <div className="normalheader transition animated fadeIn">
          <div className="hpanel">
            <div className="panel-body print-page">
              <div className="row">
                <div className="col-md-2 col-md-offset-5 spin">
                  <i className="fa fa-spinner fa-spin" />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div>
        <div
          className="hidden-print"
          style={{ minWidth: '8.5in', maxWidth: '8.5in', margin: '10px auto' }}
        >
          {/* Until we upgrade typescript this window as any is necessary */}
          <button className="btn btn-success" onClick={(window as any).print}>
            Print PDF
          </button>
        </div>

        <div className="hpanel">
          <div
            className="panel-body print-page"
            style={{
              minWidth: '8.5in',
              maxWidth: '8.5in',
              margin: 'auto',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {/**
             * Page elements are wrapped in a table because it's one of the
             * only ways to reliably get a header and footer onto each page in
             * print media.
             *
             * This is necessary as unlike in the appointment reportpage, the
             * elements of this pdf can have wildly varying heights, e.g.
             * somebody sending a wall of text in a single message; this way we
             * let print handle the page breaks for us.
             */}
            <table>
              {/* Page header */}
              <thead className="print-header">
                <tr>
                  <td>
                    <div className="row">
                      <div className="col-xs-7">
                        <h2 style={{ marginTop: '0', marginBottom: '0' }}>
                          <strong>MESSAGE EXPORT</strong>
                        </h2>
                        <div>
                          <div
                            className="col-xs-6"
                            style={{
                              padding: 0,
                              marginBottom: '1em',
                            }}
                          >
                            <h6>
                              {this.state.report.dateFrom
                                ? new Date(
                                    this.state.report.dateFrom,
                                  ).toLocaleDateString()
                                : 'Beginning of time'}
                              –
                              {this.state.report.dateTo
                                ? new Date(
                                    this.state.report.dateTo,
                                  ).toLocaleDateString()
                                : 'Now'}
                            </h6>
                          </div>
                          <div
                            className="col-xs-6"
                            style={{
                              padding: 0,
                              marginBottom: '1em',
                            }}
                          >
                            <h6>
                              {this.state.report.numberOfMessages} Message
                              {this.state.report.numberOfMessages !== 1
                                ? 's'
                                : ''}
                            </h6>
                          </div>
                        </div>
                        <h3 style={{ marginBottom: 0 }}>
                          For: {this.state.report.forUserName}
                        </h3>
                      </div>

                      <div className="col-xs-5">
                        <div className="row">
                          <div className="col-xs-6">Created By:</div>
                          <div className="col-xs-6">
                            {`${this.state.report.creator.firstName} ${this.state.report.creator.lastName}`}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xs-6">Date of Report:</div>
                          <div className="col-xs-6">
                            {new Date().toLocaleDateString()}
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </thead>

              {/* Page body */}
              <tbody
                className="print-body"
                style={{
                  display: 'flex',
                  flexFlow: 'column',
                  alignItems: 'stretch',
                  wordBreak: 'break-word',
                }}
              >
                <tr>
                  <td>
                    <div className="row">
                      <div className="col-xs-12">
                        {this.state.report.conversations.map((convo: any) => {
                          const messages = convo.messages.map(
                            (message: any) => {
                              const { firstName, lastName } =
                                convo.users.find(
                                  (user: any) => user.id === message.sender,
                                ) || {};
                              const label = firstName
                                ? `${firstName} ${lastName}`
                                : '[This user was deleted or not found]';
                              return (
                                <div key={message.id} className="content-block">
                                  <div
                                    style={{
                                      textAlign: 'center',
                                      marginTop: '1em',
                                      marginBottom: '1em',
                                    }}
                                  >
                                    {moment(message.createdAt).format(
                                      'MMM D, YYYY h:mm:ss A',
                                    )}
                                  </div>
                                  <div>{`${label}`}</div>
                                  <div>{message.body}</div>
                                </div>
                              );
                            },
                          );
                          return (
                            <div key={convo.id}>
                              <br />
                              <hr />
                              <div>
                                <strong>SUBJECT:</strong> {convo.subject}
                              </div>
                              {messages}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>

              {/* Page footer */}
              <tfoot className="print-footer">
                <tr>
                  <td>
                    <div>
                      {/**
                       * Blank footer but the css is in place to use it to
                       * define page margins.
                       */}
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
